import {CanActivateFn, Router} from '@angular/router';
import {RouteConstants} from "../constants/route-constants";
import {inject} from "@angular/core";
import {StorageService} from "../services/storage.service";
import {UtilService} from "../services/util.service";
import {of} from "rxjs";

export const brandSelectionGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const storageService = inject(StorageService);
  const authorizationId = storageService.getAuthorizationId();

  if (RouteConstants.enableBrandSelection) {
    if (authorizationId) {
      router.navigate([RouteConstants.activate.self]);
      return of(false);
    } else {
      return of(true);
    }
  } else {
    router.navigate([RouteConstants.activate.self]);
    return of(false);
  }
};
